import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { withRouter  } from 'react-router-dom';
import moment from "moment";
import 'moment/locale/ru';
import { styles } from "../../../containers/goods/styles";
import { fetchWageWithStaff, updateWages } from "../../../action/cassa";
import Loader from "../../utils/Loader";
import { fetchFilials } from "../../../action/handbook";
import ErrorContainer from "../../utils/ErrorContainer";
import BackButton from "../../utils/BackButton";
import swal from 'sweetalert';
import { parseNumToFixed } from "../../../utils/common";
import EditWagesData from "./EditWagesData";
import { fetchSettings } from "../../../action/app";
import { fetchStaffs } from "../../../action/wageFund";
import { postsIds } from "../../../constants/app";
import EditWagesStaff from "./EditWagesStaff";

const months = [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ];

function EditWages({ history, match }) {
    const initData = useSelector(state => state.cassa.wages);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const loadingPoints = useSelector(state => state.loaders.filials);
    const loadingWages = useSelector(state => state.loaders.wages);
    const loadingStaff = useSelector(state => state.loaders.staff);
    const loading = loadingPoints || loadingWages || loadingStaff;
    const settings = useSelector(state => state.settings.init);
    const staff = useSelector(state => state.wageFund.staff);

    const [data, setData] = useState({...initData});
    const [edit, setEdit] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
        const getData = async (id) => {
            const response = await dispatch(fetchWageWithStaff(id));
            if (response && response.id) return setData({...response});
            if (isEmpty(staff) || isEmpty(staff.filter((s) => s.pointId === response.pointId))) dispatch(fetchStaffs({ pointId: response.pointId }, false, true, true));
            return history.goBack();
        }
        if (!data || isEmpty(data)) {
            const id = match.params.id;
            if (!id) return history.goBack();
            getData(id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match.params.id, dispatch, history]);

    useEffect(() => {
        isEmpty(settings) && dispatch(fetchSettings());
    }, [dispatch, settings]);

    useEffect(() => {
        if (!isEmpty(data) && (isEmpty(staff) || isEmpty(staff.filter((s) => s.pointId === data.pointId)))) dispatch(fetchStaffs({ pointId: data.pointId }, true, true, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.pointId, dispatch, staff]);

    useEffect(() => {
        const getData = async () => { await dispatch(fetchFilials(null, true)) }
        if (isEmpty(points) || points.length < pointsCount) getData();
    }, [points, pointsCount, dispatch]);

    const renderPointLabel = (point) => {
        if (!point) return 'Филиал не определен';
        const cityName = point.city ? point.city.name : 'Город не указан';
        return `${cityName}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    };
    
    const date = moment(data.startOfMonthDate);
    const dateTitle = `${months[date.month()]} ${date.year()}`
    const point = points.find((p) => p.id === data.pointId);
    const pointName = renderPointLabel(point);

    if (loading) return(
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const onRefresh = async () => {
        const id = match.params.id;
        setEdit(null)
        if (!id) return history.goBack();
        const response = await dispatch(fetchWageWithStaff(id));
        if (response && response.id) return setData({...response});
        return history.goBack();
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Заработная плата</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"/>
                        <h3 className="kt-subheader__title">{pointName}</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"/>
                        <h3 className="kt-subheader__title">{dateTitle}</h3>
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"/>
                        </button>
                    </div>
                    <div className="d-flex" style={{ alignItems: 'center' }}>
                        {!edit && <BackButton />}
                    </div>
                </div>
            </div>
        );
    }

    const calculateTotal = (field, data) => {
        if (!field || !data || isEmpty(data[field])) return 0;
        const result = data[field].reduce((acc, item) => {
            acc += item.sum || 0;
            return acc;
        }, 0);
        return parseNumToFixed(result);
    }

    const renderTotalStaff = () => {
        if (isEmpty(data.staff)) return;
        return (
            <tr className="kt-datatable__row">
                <td style={{ color: '#000', width: 'auto' }} className="kt-datatable__cell"><span style={{ fontWeight: 600 }}>Итого по всем должностям</span></td>
                <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell">
                    {(data.staff || []).reduce((acc, item) => {
                        acc += +calculateTotal('payrolls', item) || 0;
                        return acc;
                    }, 0)}
                </td>
                <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell">
                    {(data.staff || []).reduce((acc, item) => {
                        acc += +calculateTotal('payments', item) || 0;
                        return acc;
                    }, 0)}
                </td>
                <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell">
                    {(data.staff || []).reduce((acc, item) => {
                        acc += +(calculateTotal('payrolls', item) || 0) - +(calculateTotal('payments', item) || 0);
                        return acc;
                    }, 0)}
                </td>
            </tr>
        )
    }

    const renderStaff = () => {
        if (isEmpty(staff) || isEmpty(postsIds)) return;

        return postsIds.map((post) => {
            const dataPostStaff = (data.staff || []).filter((dataStaff) => dataStaff.postId === post.id).map((s) => ({ ...s, isData: true })) || [];
            const staffIds = dataPostStaff.map((item) => item.staffId);
            const filteredPostStaff = staff.filter((s) => s.postId === post.id && s.pointId === data.pointId && !staffIds.includes(s.id)) || [];
            const postStaff = [ ...dataPostStaff, ...filteredPostStaff].sort((a, b) => a.name.localeCompare(b.name, 'ru'));
            
            if (isEmpty(postStaff) || postStaff.length === 0) return null;
            
            return (
                <>
                        <tr className="kt-datatable__row">
                            <td style={{ color: '#000', width: 'auto' }} className="kt-datatable__cell"><span>{post.moreLabel}</span></td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"></td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"></td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"></td>
                        </tr>
                        {postStaff.map((item) => {
                            const staffData = item.isData ? item : (data.staff || []).find((d) => d.staffId === item.id);

                            if (!isEmpty(staffData)) return (
                                <tr className="kt-datatable__row">
                                    <td style={{ cursor: 'pointer', width: 'auto' }} onClick={(() => setEdit({ value: item.isData ? item.staffId : item.id, name: item.name, dataId: staffData.id, postId: post.id }))} className="kt-datatable__cell"><span style={{ color: 'blue' }}>{item.name}</span></td>
                                    <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>{calculateTotal('payrolls', staffData)}</span></td>
                                    <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>{calculateTotal('payments', staffData)}</span></td>
                                    <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>{calculateTotal('payrolls', staffData) - calculateTotal('payments', staffData)}</span></td>
                                </tr>
                            )

                            return (
                                <tr className="kt-datatable__row">
                                    <td style={{ cursor: 'pointer', width: 'auto' }} onClick={(() => setEdit({ value: item.id, name: item.name, staffId: item.id, postId: post.id }))} className="kt-datatable__cell"><span style={{ color: 'blue' }}>{item.name}</span></td>
                                    <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>0</span></td>
                                    <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>0</span></td>
                                    <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>0</span></td>
                                </tr>
                            )
                        })}
                        <tr className="kt-datatable__row">
                            <td style={{ color: '#000', width: 'auto' }} className="kt-datatable__cell"><span style={{ fontWeight: 600 }}>Всего</span></td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell">
                                {(postStaff || []).reduce((acc, item) => {
                                    const staffData = item.isData ? item : (postStaff || []).find((d) => d.staffId === item.id);
                                    acc += +calculateTotal('payrolls', staffData) || 0;
                                    return acc;
                                }, 0)}
                            </td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell">
                                {(postStaff || []).reduce((acc, item) => {
                                    const staffData = item.isData ? item : (postStaff || []).find((d) => d.staffId === item.id);
                                    acc += +calculateTotal('payments', staffData) || 0;
                                    return acc;
                                }, 0)}
                            </td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell">
                                {(postStaff || []).reduce((acc, item) => {
                                    const staffData = item.isData ? item : (postStaff || []).find((d) => d.staffId === item.id);
                                    acc += +(calculateTotal('payrolls', staffData) || 0) - +(calculateTotal('payments', staffData) || 0);
                                    return acc;
                                }, 0)}
                            </td>
                        </tr>
                </>
            );
        })
    }

    const onSubmit = async () => {
        if (data) {
            if (!isEmpty(data.totalPayments)) data.totalPayments = data.totalPayments.sort((a, b) => a.id - b.id);
            if (!isEmpty(data.totalPayrolls)) data.totalPayrolls = data.totalPayrolls.sort((a, b) => a.id - b.id);
        }

        try {
            const result = await dispatch(updateWages(data));
            if (result) return swal({
                title: "Сохранено",
                text: "Данные успешно сохранены",
                icon: "success",
                timer: 1000,
                buttons: false,
            }).then(() => {
                setEdit(null);
                onRefresh();
            });
        } catch (error) {
            const text = [];
            const errorData = error.data || {};
            if (errorData.statusCode) text.push(`Код ошибки: ${errorData.statusCode}`);
            if (errorData.message) text.push(errorData.message);
        
            return swal({
                title: 'Ошибка сохранения данных',
                text: text.join('. '),
                icon: 'error',
                dangerMode: true,
                button: 'Ок'
            });
        }
    }

    const getIsChange = () => {
        if (isEmpty(data)) return false;
        if (data.isChange) return true;
        if (isEmpty(data.staff)) return false;
        if (data.staff.find((item) => item.isChange)) return true;
        return false;
    }

    const renderBody = () => {
        if (edit && edit.value === 'total') return <EditWagesData onRefresh={onRefresh} setData={setData} data={data} edit={edit} calculateTotal={calculateTotal}/>
        if (edit && edit.value != null && edit.value !== 'total') return <EditWagesStaff onRefresh={onRefresh} setEditWage={setEdit} setData={setData} data={data} edit={edit} calculateTotal={calculateTotal}/>
        return (
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <table className='kt-datatable__table'>
                    <thead className='kt-datatable__head'>
                        <tr className='kt-datatable__row'>
                            <th style={{ width: 'auto' }} className='kt-datatable__cell'><span>Наименование</span></th>
                            <th style={{ width: '20%' }} className='kt-datatable__cell'><span>Начисления</span></th>
                            <th style={{ width: '20%' }} className='kt-datatable__cell'><span>Выплаты</span></th>
                            <th style={{ width: '20%' }} className='kt-datatable__cell'><span>Остаток</span></th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        <tr className="kt-datatable__row">
                            <td style={{ cursor: 'pointer', width: 'auto' }} onClick={(() => setEdit({ value: 'total', name: 'Общие' }))} className="kt-datatable__cell"><span style={{ color: 'blue' }}>Общие</span></td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>{calculateTotal('totalPayrolls', data)}</span></td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>{calculateTotal('totalPayments', data)}</span></td>
                            <td style={{ color: '#000', width: '20%' }} className="kt-datatable__cell"><span>{calculateTotal('totalPayrolls', data) - calculateTotal('totalPayments', data)}</span></td>
                        </tr>
                        {renderStaff()}
                        {renderTotalStaff()}
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <>
            {renderSubHeader()}
            <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                    
                <div className="kt-portlet">
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            {renderBody()}
                        </div>
                        <ErrorContainer field="wages" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions" style={{ display: 'flex', gap: 10 }}>
                                {edit &&
                                <button className="btn btn-secondary" onClick={() => setEdit(null)}>
                                    Назад
                                </button>
                                }
                                {getIsChange() &&
                                <button className="btn btn-primary" onClick={onSubmit}>
                                    Сохранить
                                </button>
                                }
                            </div>
                        </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(EditWages);